import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import {
  CompanyDirectorySource,
  CompanyProfileSuggestion,
} from '@savgroup-front-common/types/CompanyDirectory';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

export interface SuggestCompanyProfileCommandArgs {
  source: CompanyDirectorySource;
  registrationNumber: string;
  language?: string;
}

export const suggestCompanyProfileRequest = ({
  source,
  registrationNumber,
  language,
}: SuggestCompanyProfileCommandArgs): ApiRequestDescriptor => ({
  url: buildUrl(`${APIConfiguration.seller}companies/profile`),
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { source, registrationNumber, language },
  },
});

export async function suggestCompanyProfileCommand({
  source,
  registrationNumber,
  language,
}: SuggestCompanyProfileCommandArgs): Promise<
  BackResponseFailure | BackResponse<CompanyProfileSuggestion>
> {
  try {
    return await executeQuery<BackResponse<CompanyProfileSuggestion>>(
      suggestCompanyProfileRequest({ source, registrationNumber, language }),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
